import type { PageLoad } from "./$types";
import type { Maybe, Place, PlaceType, Map } from "../../../types";
import { error } from "@sveltejs/kit";
import { parseId } from "../../../params/slug";

export const load: PageLoad = async function ({ params, parent }) {
  const { heraldMap, places, placeTypes, placeHoursGroups } = await parent();
  const id = parseId(params.id);
  const place = places.find((place) => place.id == id);

  if (place == null) {
    error(404, "Place not found");
  }

  return {
    place: place,
    places: places,
    parent: places.find((p: Place) => p.id == place.parentId) as Maybe<Place>,
    placeTypes: placeTypes.filter((placeType: PlaceType) => {
      return new Set(placeType.placeIds).has(id as string);
    }),
    children: places.filter((p: Place) => p.parentId == id) as Place[],
    placeHoursGroup: placeHoursGroups.find((phg) => phg.id == place.placeHoursGroupId),
    map: heraldMap as Map,
    pageTitle: place.title,
    pageDescription: place.description
  };
};
